var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0435599 5.55319C1.24123 8.46194 3.97257 10.3369 7 10.3369C10.0274 10.3369 12.7588 8.46194 13.9564 5.55319C14.0145 5.41369 14.0145 5.2602 13.9564 5.12069C12.7588 2.21194 10.0274 0.336945 7 0.336945C3.97257 0.336945 1.24123 2.21194 0.0435599 5.12069C-0.01452 5.2602 -0.01452 5.41369 0.0435599 5.55319ZM7 1.33694C9.36104 1.33694 11.9654 3.05132 13 5.33694C11.9654 7.62257 9.36104 9.33694 7 9.33694C4.63895 9.33694 2.03458 7.62257 1 5.33694C2.03458 3.05132 4.63895 1.33694 7 1.33694ZM7 7.83694C8.27946 7.83694 9.5 6.61458 9.5 5.33694C9.5 4.05931 8.32837 2.88498 7 2.88498C5.67163 2.88498 4.5 4.04682 4.5 5.33694C4.5 6.62707 5.72054 7.83694 7 7.83694ZM7 3.83694C7.89376 3.83694 8.5 4.37808 8.5 5.33694C8.5 6.13084 8 6.83694 7 6.83694C6 6.83694 5.5 6.00138 5.5 5.33694C5.5 4.57556 6 3.83694 7 3.83694Z",
    fill: "#4A4D55"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye.a0fd84bde0fc6d42e5542f8aa8b2d305.svg";